import CekKeluarMasukEditorMain from "../../features/cek-keluar-masuk/cek-keluar-masuk-mobil/cek-keluar-masuk-mobil-editor/component/CekKeluarMasukEditorMain";

const CekKeluarMasukEditorPage = () => {
  return <CekKeluarMasukEditorMain />;
};

export default CekKeluarMasukEditorPage;
